import React from 'react';

export const Contact = () => {
  return (
    <div id='contact'>
      <div id='footer'>
        <div className='footer-bottom'>
          <p>
            &copy; 2021 Rogpe *
            <a href='https://github.com/Rogpe-Prog' rel='nofollow'>
              github
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}
